/*
  Shop's "Follow on Shop" button hard-codes black text (a `text-black` class in its
  open shadow root) and has no setting for a dark background, so on our scheme-2
  footer it was unreadable. Swap in Shop's own `text-white` class, and re-apply
  whenever the component re-renders (following / unfollowing rebuilds it).
*/
(() => {
  const lighten = (root) =>
    root.querySelectorAll('.text-black').forEach((el) => el.classList.replace('text-black', 'text-white'));

  const watch = (host) => {
    if (host.dataset.lightWatched || !host.shadowRoot) return;
    host.dataset.lightWatched = '1';
    lighten(host.shadowRoot);
    new MutationObserver(() => lighten(host.shadowRoot)).observe(host.shadowRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const scan = () => document.querySelectorAll('.footer__follow-on-shop shop-follow-button').forEach(watch);
  scan();
  // The shadow root attaches after the element upgrades, so keep checking briefly.
  let tries = 0;
  const timer = setInterval(() => { scan(); if (++tries >= 20) clearInterval(timer); }, 500);
})();
